<div class="fast-container">

  <!-- ══ VIDEO PLAYER ══ -->
  <div class="video-section">
    <video #videoElement controls></video>
  </div>

  <!-- ══ EPG SCHEDULE ══ -->
  <div class="epg-wrap">

    <!-- Header -->
    <div class="epg-header">
      <div class="hdr-ch">Channels</div>
      <div class="hdr-now">
        <span class="hdr-label accent">NOW</span>
        <span class="hdr-time">{{ currentTime | date:'hh:mm a' }}</span>
      </div>
      <div class="hdr-next"><span class="hdr-label muted">NEXT</span></div>
      <div class="hdr-later"><span class="hdr-label muted">LATER</span></div>
    </div>

    <!-- Channel Rows -->
    <div class="epg-row" *ngFor="let ch of channels">

      <!-- ── Channel Card ── -->
      <div class="col-ch">
        <div class="ch-card" [class.active]="ch === activeChannel" (click)="selectChannel(ch)">
          <div class="logo-box">
            <img [src]="ch.logo" [alt]="ch.title">
          </div>
          <span class="ch-name">{{ ch.title }}</span>
        </div>
      </div>

      <!-- ── NOW Card ── -->
      <div class="col-now">
        <div class="prog-card now-card">
          <ng-container *ngIf="ch.nowPlaying; else nowEmpty">
            <p class="prog-title">{{ ch.nowPlaying.title }}</p>
            <p class="prog-desc">{{ ch.nowPlaying.desc }}</p>
            <div class="prog-meta">
              <span class="mins-left">{{ ch.nowPlaying.minsLeft }}</span>
              <span class="prog-time">{{ ch.nowPlaying.start_time | date:'hh:mm' }} – {{ ch.nowPlaying.end_time | date:'hh:mm a' }}</span>
            </div>
            <div class="prog-bar">
              <div class="prog-fill" [style.width.%]="ch.nowPlaying.progressPct"></div>
            </div>
          </ng-container>
          <ng-template #nowEmpty>
            <span class="empty-txt">No program scheduled</span>
          </ng-template>
        </div>
      </div>

      <!-- ── NEXT Card ── -->
      <div class="col-next">
        <div class="prog-card side-card">
          <ng-container *ngIf="ch.nextProgram">
            <p class="prog-title">{{ ch.nextProgram.title }}</p>
            <p class="prog-desc">{{ ch.nextProgram.desc }}</p>
            <p class="prog-time">{{ ch.nextProgram.start_time | date:'hh:mm' }} – {{ ch.nextProgram.end_time | date:'hh:mm a' }}</p>
            </ng-container>
          <ng-container *ngIf="!ch.nextProgram">
            <span class="empty-txt">—</span>
          </ng-container>
        </div>
      </div>

      <!-- ── LATER Card ── -->
      <div class="col-later">
        <div class="prog-card side-card">
          <ng-container *ngIf="ch.laterProgram">
            <p class="prog-title">{{ ch.laterProgram.title }}</p>
            <p class="prog-desc">{{ ch.laterProgram.desc }}</p>
            <p class="prog-time">{{ ch.laterProgram.start_time | date:'hh:mm' }} – {{ ch.laterProgram.end_time | date:'hh:mm a' }}</p>
            </ng-container>
          <ng-container *ngIf="!ch.laterProgram">
            <span class="empty-txt">—</span>
          </ng-container>
        </div>
      </div>

    </div>
    <!-- /rows -->

  </div>
  <!-- /epg -->

</div>
